import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import QRCodeScanner from "./QRCodeScanner"; // adjust path if needed

import "./FormPage.css";
import content from "../static/content.json";
import { useLocation } from "react-router-dom";

const Login = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showScanner, setShowScanner] = useState(false);
  const [scanResult, setScanResult] = useState("");
  const [redirecting, setRedirecting] = useState(false);
  const [cameraFacingMode, setCameraFacingMode] = useState("environment");
  const caseId = localStorage.getItem("caseId");
  const staticText = content.Login;

  const location = useLocation();
  const scannerComponentRef = useRef();


useEffect(() => {
  if (location.pathname === "/demo") {
    alert(
      "Sie befinden sich im Demo-Modus. Sie werden zum Feedback-Formular weitergeleitet..."
    );
    localStorage.setItem("caseId", "demo");

    setTimeout(() => {
      navigate("/feedback");
    }, 2000);
  }
}, [location.pathname, navigate]);

const handleEmailLogin = async () => {
    if (username === "demo" && password === "demo") {
      localStorage.setItem("isAuthenticated", true);
      localStorage.setItem("userId", "demo");
      localStorage.setItem("apiToken", "demoToken");

      setIsAuthenticated(true);
      if (caseId) {
        navigate("/form");
      } else {
        navigate("/overview");
      }
    } else {
      try {
        const response = await axios.post(
          "https://app.better-retter.de/api/login",
          // "asdasd",
          {
            username,
            password,
            software: "better-retter",
          }
        );

        if (response.data.success === true) {
          localStorage.setItem("isAuthenticated", true);
          localStorage.setItem("userId", response.data.id);
          localStorage.setItem("apiToken", response.data.api_token);

          setIsAuthenticated(true);
          if (caseId) {
            navigate("/form");
          } else {
            navigate("/overview");
          }
        } else {
          alert("Incorrect username or password");
        }
      } catch (error) {
        console.error("Login error:", error);
        alert("An error occurred during login. Please try again.");
      }
    }
  };

  const handleScanQR = () => {
    setShowScanner(true);
  };
const handleToggleCamera = () => {
  setCameraFacingMode((prevMode) =>
    prevMode === "environment" ? "user" : "environment"
  );
};

const handleScan = async (scannedText) => {
  if (!scannedText) return;

  if (scannerComponentRef.current) {
    try {
      await scannerComponentRef.current.stop();
    } catch (err) {
      // silently fail if scanner is already stopped
    }
  }

  setShowScanner(false);

  if (scannedText.includes("/demo")) {
    alert("Demo-Modus erkannt. Sie werden weitergeleitet...");
    localStorage.setItem("caseId", "demo");

    setTimeout(() => {
      navigate("/feedback");
    }, 2000);
    return;
  }

  const match = scannedText.match(/submit\/(.+)/);
  if (match) {
    const extractedPart = match[1];
    setScanResult(extractedPart);
    setRedirecting(true);
    setTimeout(() => {
      navigate("/form");
    }, 2000);
  } else {
    alert("Ungültiger QR-Code");
  }
};


const handleCloseScanner = async () => {
  if (scannerComponentRef.current) {
    await scannerComponentRef.current.stop();
  }
  setShowScanner(false);
};


  const handleError = (err) => {
    console.error("QR Code Scan Error:", err);
  };

  const handleFeedbackClick = () => {
    if (caseId) {
      alert(
        "Da Sie sich in der Demoversion befinden, besitzen Sie bereits eine Fall-ID, aber in einem echten Anwendungsfall wird davon ausgegangen, dass Sie in erster Linie einen QR-Code (Fall ID) benötigen."
      );
      navigate("/feedback");
    } else {
      alert(
        "Um ein Feedback zu einem bestimmten Fall zu geben, scannen Sie bitte den entsprechenden QR-Code des Patienten."
      );
      handleScanQR();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleEmailLogin(e);
    }
  };

  return (
    <div className="form-box">
      {" "}
      {/* New container box */}
      {/* Hospital Staff Section */}
      <div className="hos-container">
        <p>
          <strong>{staticText.MessageForReviewer}</strong>
        </p>
        <button className="info-button" onClick={handleFeedbackClick}>
          {staticText.ReviewButton}
        </button>
        {showScanner && (
          <div className="scanner-container">
            <QRCodeScanner
              key={cameraFacingMode}
              ref={scannerComponentRef}
              facingMode={cameraFacingMode}
              onScanSuccess={handleScan}
              onScanError={handleError}
            />

            <button
              className="form-button form-button-primary"
              onClick={handleCloseScanner}
              style={{ marginTop: "10px", background: "red", color: "white" }}
            >
              Abbrechen
            </button>
            <button
              className="form-button form-button-primary"
              onClick={handleToggleCamera}
              style={{ background: "blue", color: "white" }}
            >
              Kamera wechseln
            </button>
          </div>
        )}
      </div>
      {/* Paramedical Login Section */}
      <div className="form-content">
        <div className="info-container">
          <p>
            <strong>{staticText.MessageForRescuer}</strong>
          </p>
        </div>
        <h1>Login</h1>
        <div className="form-group">
          <label className="form-label" htmlFor="username">
            Benutzername:
          </label>
          <input
            className="form-input"
            type="email"
            id="username"
            placeholder="max.mustermann@email.com"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="password">
            Passwort:
          </label>
          <input
            className="form-input"
            type="password"
            id="password"
            placeholder="Kennwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <button
          type="submit"
          className="form-button form-button-primary"
          onClick={handleEmailLogin}
        >
          Login
        </button>

        {/* <div className="form-group">
          <h2>Or Log in with</h2>
          <button className="form-button form-button-secondary" onClick={handleGoogleLogin}>
            Google
          </button>
          <button className="form-button form-button-secondary" onClick={handleAppleLogin}>
            Apple
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Login;
